import { useNavigate } from 'react-router-dom'

import {
  NewMaterialLinkDocument,
  TrainingDetailMaterialsDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewLinkModal } from 'modules/trainings/components/NewLinkModal'

export default function NewMaterialLink() {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const session = useCurrentSession()
  const { id } = useStrictParams<'id'>()
  const [createTrainingLink] = useMutation(NewMaterialLinkDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingLink,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingDetailMaterialsDocument],
  })

  return (
    <NewLinkModal
      description={i18n.t(
        'trainings.trainings_revamp.training_detail.materials.new_link_modal.description'
      )}
      title={i18n.t('trainings.trainings_revamp.training_detail.materials.new_link_modal.title')}
      onSubmit={async (data) => {
        const result = await createTrainingLink({
          variables: {
            trainingId: String(id),
            title: data.title,
            url: data.url,
            authorId: session.access.id,
            companyId: session.company.id,
          },
        })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t(
              'trainings.trainings_revamp.training_detail.materials.new_link_modal.submit_error'
            ),
          })
        })
        if (handled.success) {
          navigate(navigation.trainings.list.details_revamp.view.attachments.fullPath({ id }))
        }
      }}
      onClose={() => {
        navigate(navigation.trainings.list.details_revamp.view.attachments.fullPath({ id }))
      }}
    />
  )
}
